import React from 'react';

interface SortArrowsProps {
  direction?: 'ascend' | 'descend' | null;
}

const getDownOpacity = (direction: SortArrowsProps['direction']) => {
  if (direction === 'descend') {
    return 1;
  }
  if (direction === 'ascend') {
    return 0.35;
  }
  return 1;
};

const getUpOpacity = (direction: SortArrowsProps['direction']) => {
  if (direction === 'ascend') {
    return 1;
  }
  if (direction === 'descend') {
    return 0.35;
  }
  return 1;
};

export const SortArrows: React.FC<SortArrowsProps> = ({ direction = null }) => (
  <svg width="12" height="11" viewBox="0 0 12 11" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M4.5 2.5L2.5 0.5L0.5 2.5"
      stroke="currentColor"
      opacity={getUpOpacity(direction)}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2.50033 9.83333V0.5"
      stroke="currentColor"
      opacity={getUpOpacity(direction)}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.16699 7.83325L9.16699 9.83325L11.167 7.83325"
      stroke="currentColor"
      opacity={getDownOpacity(direction)}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.16683 0.5V9.83333"
      stroke="currentColor"
      opacity={getDownOpacity(direction)}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
